<script lang="ts">
  import { QueryClientProvider } from '@tanstack/svelte-query';
  import App from './App.svelte';
  import type { BrowserStore } from './platform/storage';
  import { queryClient } from './queries/query-client';
  import type { Appearance } from './themes/appearance.svelte';

  interface Props {
    store: BrowserStore;
    appearance: Appearance;
  }
  let { store, appearance }: Props = $props();
</script>

<QueryClientProvider client={queryClient}>
  <App {store} {appearance} />
</QueryClientProvider>
